import { useTranslation } from 'react-i18next';

import type { PrivacyRequestStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<PrivacyRequestStatus, string> = {
  received: 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  in_progress: 'bg-primary/10 text-foreground border-transparent',
  completed: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  rejected: 'border-border text-muted-foreground',
};

export function PrivacyRequestStatusBadge({
  status,
  className,
}: {
  status: PrivacyRequestStatus;
  className?: string;
}) {
  const { t } = useTranslation('privacyRequests');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
